var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$s.Loading,attrs:{"aria-hidden":"true"}},[_c('m-icon',{class:_vm.$s.Spinner,attrs:{"size":_vm.size,"name":"spinner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }